import React, { useEffect, useState } from "react";
import ActivityCalendar from "react-activity-calendar";

// GitHub contribution heatmap for the last 12 months (like the graph on a
// GitHub profile), plus the all-time total.
// Data comes from the public github-contributions-api, the same source
// react-github-calendar uses.

const API_URL = "https://github-contributions-api.jogruber.de/v4/";

const pad = (n) => String(n).padStart(2, "0");
const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

function Contributions({ username, theme, colorScheme }) {
  const [state, setState] = useState({ status: "loading" });

  const today = new Date();
  const to = isoDate(today);
  const from = isoDate(new Date(today.getFullYear() - 1, today.getMonth(), today.getDate() + 1));

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}${username}?y=all`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((json) => {
        if (cancelled) return;
        const days = (json.contributions || [])
          .filter((d) => d.date >= from && d.date <= to)
          .sort((a, b) => (a.date < b.date ? -1 : 1));
        const allTime = Object.values(json.total || {}).reduce((sum, n) => sum + n, 0);
        setState({ status: "ready", days, allTime });
      })
      .catch(() => !cancelled && setState({ status: "error" }));
    return () => {
      cancelled = true;
    };
  }, [username, from, to]);

  if (state.status === "error") {
    return <div className="muted small">Contribution data is unavailable right now.</div>;
  }

  const ready = state.status === "ready" && state.days.length > 0;
  return (
    <>
      <ActivityCalendar
        data={ready ? state.days : []}
        loading={!ready}
        theme={theme}
        colorScheme={colorScheme}
        blockSize={10}
        blockMargin={3}
        fontSize={12}
        hideColorLegend
        hideTotalCount
        labels={{ tooltip: "{{count}} contributions on {{date}}" }}
      />
      <div className="heat-meta small">
        <span className="heat-total">
          <b>{ready ? state.allTime.toLocaleString() : "…"}</b>
          <span className="muted"> contributions since 2012</span>
        </span>
      </div>
    </>
  );
}

export default Contributions;
